import { canAccessArea } from "utils/gestion-access";

export const SETTINGS_TABS = ["details", "managers", "venues", "customFields", "scheduling", "matchSheet"];

// Detalles and Administradores are manager-only; the rest belong to Torneos.
export const SETTINGS_TAB_AREAS = {
  details: "manager",
  managers: "manager",
  venues: "tournaments",
  customFields: "tournaments",
  scheduling: "tournaments",
  matchSheet: "tournaments",
};

// Not built for Gestión yet: hidden for every role (Reva admins included). The tab bodies stay in GestionSettings.
export const HIDDEN_SETTINGS_TABS = ["customFields", "scheduling"];

export const visibleSettingsTabs = (access) =>
  SETTINGS_TABS.filter((tab) => !HIDDEN_SETTINGS_TABS.includes(tab) && canAccessArea(access, SETTINGS_TAB_AREAS[tab]));

export const resolveActiveSettingsTab = (current, visible) =>
  visible.includes(current) ? current : (visible[0] ?? null);
